// import React, { useState } from "react";
// import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa"; // Importing icons

// const ContactUs = () => {
//     const [formData, setFormData] = useState({
//         name: "",
//         mobile: "",
//         email: "",
//         subject: "",
//         message: "",
//     });

//     const [errors, setErrors] = useState({});

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };

//     const validate = () => {
//         const newErrors = {};
//         if (!formData.name.trim()) newErrors.name = "Name is required.";
//         const mobileRegex = /^[0-9]{10}$/;
//         if (!formData.mobile.trim()) {
//             newErrors.mobile = "Mobile number is required.";
//         } else if (!mobileRegex.test(formData.mobile)) {
//             newErrors.mobile = "Enter a valid 10-digit mobile number.";
//         }
//         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         if (!formData.email.trim()) {
//             newErrors.email = "Email is required.";
//         } else if (!emailRegex.test(formData.email)) {
//             newErrors.email = "Enter a valid email address.";
//         }
//         if (!formData.subject.trim()) newErrors.subject = "Subject is required.";
//         if (!formData.message.trim()) newErrors.message = "Message is required.";

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         if (validate()) {
//             console.log("Form submitted successfully:", formData);
//             setFormData({
//                 name: "",
//                 mobile: "",
//                 email: "",
//                 subject: "",
//                 message: "",
//             });
//             alert("Form submitted successfully!");
//         } else {
//             console.log("Form contains errors:", errors);
//         }
//     };



//     // const scriptURL = 'https://script.google.com/macros/s/AKfycbxaZ5YtKd2rXWqkgjPyC90mlT7l3eIWi5a5tpHL60yL5R_hunDvqLbBdF3xWkejAKI_/exec'
//     // const form = document.forms['submit-to-google-sheet']
//     // const msg = document.getElementById("msg")

//     // form.addEventListener('submit', e => {
//     //     e.preventDefault()
//     //     fetch(scriptURL, { method: 'POST', body: new FormData(form) })
//     //         .then(response => {
//     //             msg.innerHTML = "Thanks for submit the feedback form!";
//     //             setTimeout(function () {
//     //                 msg.innerHTML = ""
//     //             }, 5000)
//     //             form.reset()
//     //         })
//     //         .catch(error => console.error('Error!', error.message))
//     // })




//     const scriptURL = 'https://script.google.com/macros/s/AKfycbyi-EHZx07fXU-zMApKwMWAfRA72Jd97e-JW3K3icNVWvJqVFKc8wgxaN_g6VINs6Pgog/exec';
//         const form = document.forms['google-sheet'];

//         form.addEventListener('submit', e => {
//             e.preventDefault();

//             fetch(scriptURL, { method: 'POST', body: new FormData(form) })
//                 .then(response => {
//                     setTimeout(function () {
//                         alert("Thanks for contacting us! We will get back to you soon.");
//                     }, 500);
//                     form.reset();
//                 })
//                 .catch(error => console.error('Error!', error.message));
//         });




//     return (
//         <div className="py-10 px-4 md:px-20 bg-gray-100">
//             <div className="items-center text-center">
//                 <h1 className="font-extrabold text-2xl md:text-3xl text-purple-800 mb-4">
//                     Contact Us
//                 </h1>
//                 <p className="font-bold text-lg md:text-xl text-blue-800 mb-10">
//                     We provide high standard work for your Company solutions
//                 </p>
//             </div>
//             <div className="flex flex-col md:flex-row items-start md:items-stretch justify-center gap-8">
//                 {/* Contact Information Section */}
//                 <div className="w-full md:w-1/2 bg-white shadow-md rounded-lg p-6 flex flex-col justify-between">
//                     <div className="grid grid-cols-1 gap-6">
//                         <div className="flex flex-col items-center bg-gray-50 shadow-sm rounded-lg p-4">
//                             <span className="flex flex-row gap-4">
//                                 <FaPhoneAlt className="text-purple-600 text-3xl mb-3" />
//                                 <p className="text-lg font-bold text-purple-800">Mobile</p>
//                             </span>
//                             <p className="text-gray-600">+91 9909152383</p>
//                         </div>
//                         <div className="flex flex-col items-center bg-gray-50 shadow-sm rounded-lg p-4">
//                             <span className="flex flex-row gap-4">
//                                 <FaEnvelope className="text-purple-600 text-3xl mb-3" />
//                                 <p className="text-lg font-bold text-purple-800">Email</p>
//                             </span>
//                             <p className="text-gray-600">sales.powergenic@gmail.com</p>
//                         </div>
//                         <div className="flex flex-col items-center bg-gray-50 shadow-sm rounded-lg p-4">
//                             <span className="flex flex-row gap-4">
//                                 <FaMapMarkerAlt className="text-purple-600 text-3xl mb-3" />
//                                 <p className="text-lg font-bold text-purple-800">Location</p>
//                             </span>
//                             <p className="text-gray-600">Fatima Society, Madhunagar Gorwa, Vadodara, Country-India, 390016</p>
//                         </div>
//                     </div>
//                     <div className="mt-6">
//                         <iframe
//                             src="https://maps.google.com/maps?q=D/177%20Fatima%20Park,%20Nr.%20Madhunagar,%20Gorwa,%20Vadodara,%20Gujarat%20390016&z=13&ie=UTF8&iwloc=&output=embed"
//                             width="100%"
//                             height="250"
//                             frameBorder="0"
//                             style={{ border: "2px" }}
//                             allowFullScreen
//                             title="Google Map"
//                             className="w-full rounded-lg shadow-md"
//                         ></iframe>
//                     </div>
//                 </div>

//                 {/* Contact Form Section */}
//                 <div className="w-full md:w-1/2 bg-white shadow-md rounded-lg p-6">
//                     <h2 className="text-xl md:text-2xl font-bold text-purple-800 mb-6">
//                         Get In Touch
//                     </h2>
//                     <form onSubmit={handleSubmit} name="google-sheet" method="POST" id="form">
//                         <div className="grid grid-cols-1 gap-6">
//                             <div>
//                                 <label className="block text-gray-700 font-medium mb-2">
//                                     Name
//                                 </label>
//                                 <input
//                                     type="text"
//                                     name="name"
//                                     value={formData.name}
//                                     onChange={handleChange}
//                                     placeholder="Enter your name"
//                                     className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
//                                 />
//                                 {errors.name && (
//                                     <p className="text-red-500 text-sm mt-1">{errors.name}</p>
//                                 )}
//                             </div>
//                             <div>
//                                 <label className="block text-gray-700 font-medium mb-2">
//                                     Mobile Number
//                                 </label>
//                                 <input
//                                     type="text"
//                                     name="mobile"
//                                     value={formData.mobile}
//                                     onChange={handleChange}
//                                     placeholder="Enter your mobile number"
//                                     className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
//                                 />
//                                 {errors.mobile && (
//                                     <p className="text-red-500 text-sm mt-1">{errors.mobile}</p>
//                                 )}
//                             </div>
//                             <div>
//                                 <label className="block text-gray-700 font-medium mb-2">
//                                     Email
//                                 </label>
//                                 <input
//                                     type="email"
//                                     name="email"
//                                     value={formData.email}
//                                     onChange={handleChange}
//                                     placeholder="Enter your email"
//                                     className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
//                                 />
//                                 {errors.email && (
//                                     <p className="text-red-500 text-sm mt-1">{errors.email}</p>
//                                 )}
//                             </div>
//                             <div>
//                                 <label className="block text-gray-700 font-medium mb-2">
//                                     Subject
//                                 </label>
//                                 <input
//                                     type="text"
//                                     name="subject"
//                                     value={formData.subject}
//                                     onChange={handleChange}
//                                     placeholder="Enter the subject"
//                                     className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
//                                 />
//                                 {errors.subject && (
//                                     <p className="text-red-500 text-sm mt-1">{errors.subject}</p>
//                                 )}
//                             </div>
//                         </div>
//                         <div className="mt-6">
//                             <label className="block text-gray-700 font-medium mb-2">
//                                 Message
//                             </label>
//                             <textarea
//                                 name="message"
//                                 value={formData.message}
//                                 onChange={handleChange}
//                                 rows="5"
//                                 placeholder="Write your message"
//                                 className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
//                             ></textarea>
//                             {errors.message && (
//                                 <p className="text-red-500 text-sm mt-1">{errors.message}</p>
//                             )}
//                         </div>
//                         <div className="mt-6 text-center">
//                             <button
//                                 type="submit"
//                                 value="Send Message"
//                                 className="btn bg-blue-800 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition duration-300"
//                             >
//                                 Submit
//                             </button>
//                         </div>
//                     </form>
//                     {/* <span id="msg" className="text-success"></span> */}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ContactUs;









// import React, { useState } from "react";
// import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

// const ContactUs = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     subject: "",
//     message: "",
//   });

//   const [errors, setErrors] = useState({});
//   const [successMessage, setSuccessMessage] = useState("");

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const validate = () => {
//     const newErrors = {};
//     if (!formData.name.trim()) newErrors.name = "Name is required.";
//     const mobileRegex = /^[0-9]{10}$/;
//     if (!formData.mobile.trim()) {
//       newErrors.mobile = "Mobile number is required.";
//     } else if (!mobileRegex.test(formData.mobile)) {
//       newErrors.mobile = "Enter a valid 10-digit mobile number.";
//     }
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!formData.email.trim()) {
//       newErrors.email = "Email is required.";
//     } else if (!emailRegex.test(formData.email)) {
//       newErrors.email = "Enter a valid email address.";
//     }
//     if (!formData.subject.trim()) newErrors.subject = "Subject is required.";
//     if (!formData.message.trim()) newErrors.message = "Message is required.";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (validate()) {
//       try {
//         const scriptURL =
//           "https://script.google.com/macros/s/AKfycbxaZ5YtKd2rXWqkgjPyC90mlT7l3eIWi5a5tpHL60yL5R_hunDvqLbBdF3xWkejAKI_/exec";

//         const response = await fetch(scriptURL, {
//           method: "POST",
//           body: new URLSearchParams(formData),
//         });

//         if (response.ok) {
//           setSuccessMessage("Thanks for submitting the feedback form!");
//           setFormData({
//             name: "",
//             mobile: "",
//             email: "",
//             subject: "",
//             message: "",
//           });
//           setErrors({});
//           setTimeout(() => setSuccessMessage(""), 5000); // Clear success message after 5 seconds
//         } else {
//           console.error("Error submitting the form!");
//         }
//       } catch (error) {
//         console.error("Error!", error.message);
//       }
//     }
//   };

//   return (
//     <div className="py-10 px-4 md:px-20 bg-gray-100">
//       <div className="text-center">
//         <h1 className="font-extrabold text-2xl md:text-3xl text-purple-800 mb-4">
//           Contact Us
//         </h1>
//         <p className="font-bold text-lg md:text-xl text-blue-800 mb-10">
//           We provide high-standard work for your company solutions
//         </p>
//       </div>
//       <div className="flex flex-col md:flex-row items-start justify-center gap-8">
//         <div className="w-full md:w-1/2 bg-white shadow-md rounded-lg p-6">
//           <div className="grid gap-6">
//             <div className="flex flex-col items-center bg-gray-50 shadow-sm rounded-lg p-4">
//               <span className="flex items-center gap-4">
//                 <FaPhoneAlt className="text-purple-600 text-3xl" />
//                 <p className="text-lg font-bold text-purple-800">Mobile</p>
//               </span>
//               <p className="text-gray-600">+91 9909152383</p>
//             </div>
//             <div className="flex flex-col items-center bg-gray-50 shadow-sm rounded-lg p-4">
//               <span className="flex items-center gap-4">
//                 <FaEnvelope className="text-purple-600 text-3xl" />
//                 <p className="text-lg font-bold text-purple-800">Email</p>
//               </span>
//               <p className="text-gray-600">sales.powergenic@gmail.com</p>
//             </div>
//             <div className="flex flex-col items-center bg-gray-50 shadow-sm rounded-lg p-4">
//               <span className="flex items-center gap-4">
//                 <FaMapMarkerAlt className="text-purple-600 text-3xl" />
//                 <p className="text-lg font-bold text-purple-800">Location</p>
//               </span>
//               <p className="text-gray-600">
//                 Fatima Society, Madhunagar Gorwa, Vadodara, Country-India, 390016
//               </p>
//             </div>
//           </div>
//         </div>
//         <div className="w-full md:w-1/2 bg-white shadow-md rounded-lg p-6">
//           <h2 className="text-xl md:text-2xl font-bold text-purple-800 mb-6">
//             Get In Touch
//           </h2>
//           <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             {/* Full Name */}
//             <div>
//               <label className="block text-gray-700 font-medium mb-2">
//                 Full Name<span className="text-red-500 font-bold">*</span>
//               </label>
//               <input
//                 type="text"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
//                 placeholder="Your Name"
//               />
//               {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
//             </div>

//             {/* Email */}
//             <div>
//               <label className="block text-gray-700 font-medium mb-2">
//                 Email<span className="text-red-500 font-bold">*</span>
//               </label>
//               <input
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
//                 placeholder="Your Email"
//               />
//               {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
//             </div>

//             {/* Mobile */}
//             <div>
//               <label className="block text-gray-700 font-medium mb-2">
//                 Mobile<span className="text-red-500 font-bold">*</span>
//               </label>
//               <input
//                 type="text"
//                 name="mobile"
//                 value={formData.mobile}
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
//                 placeholder="Your Mobile"
//               />
//               {errors.mobile && <p className="text-red-500 text-sm">{errors.mobile}</p>}
//             </div>

//             {/* Subject */}
//             <div>
//               <label className="block text-gray-700 font-medium mb-2">
//                 Subject<span className="text-red-500 font-bold">*</span>
//               </label>
//               <input
//                 type="text"
//                 name="subject"
//                 value={formData.subject}
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
//                 placeholder="Subject"
//               />
//               {errors.subject && <p className="text-red-500 text-sm">{errors.subject}</p>}
//             </div>

//             {/* Message */}
//             <div className="col-span-1 md:col-span-2">
//               <label className="block text-gray-700 font-medium mb-2">
//                 Message<span className="text-red-500 font-bold">*</span>
//               </label>
//               <textarea
//                 name="message"
//                 value={formData.message}
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
//                 rows="5"
//                 placeholder="Your Message"
//               ></textarea>
//               {errors.message && <p className="text-red-500 text-sm">{errors.message}</p>}
//             </div>

//             <div className="col-span-1 md:col-span-2 flex justify-center">
//               <button
//                 type="submit"
//                 className="bg-green-500 text-white px-6 py-2 rounded-lg hover:bg-green-600 transition duration-300"
//               >
//                 Submit
//               </button>
//             </div>
//           </form>
//           {successMessage && (
//             <span id="msg" className="text-green-500 block text-center mt-4">
//               {successMessage}
//             </span>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ContactUs;











// import React, { useState } from "react";
// import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa"; // Importing icons
// import axios from 'axios';



// const ContactUs = () => {
//     const [formData, setFormData] = useState({
//         name: "",
//         mobile: "",
//         email: "",
//         subject: "",
//         message: "",
//     });

//     const [errors, setErrors] = useState({});
//     const [submissionStatus, setSubmissionStatus] = useState("");

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };

//     const validate = () => {
//         const newErrors = {};
//         if (!formData.name.trim()) newErrors.name = "Name is required.";
//         const mobileRegex = /^[0-9]{10}$/;
//         if (!formData.mobile.trim()) {
//             newErrors.mobile = "Mobile number is required.";
//         } else if (!mobileRegex.test(formData.mobile)) {
//             newErrors.mobile = "Enter a valid 10-digit mobile number.";
//         }
//         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         if (!formData.email.trim()) {
//             newErrors.email = "Email is required.";
//         } else if (!emailRegex.test(formData.email)) {
//             newErrors.email = "Enter a valid email address.";
//         }
//         if (!formData.subject.trim()) newErrors.subject = "Subject is required.";
//         if (!formData.message.trim()) newErrors.message = "Message is required.";

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     // const handleSubmit = (e) => {
//     //     e.preventDefault();
//     //     if (validate()) {
//     //         const scriptURL = 'https://script.google.com/macros/s/AKfycbzjG1c42px0nGItjKuCubguHpptnwoWT11pcbQ5iNMRKJpqqm9zBsYwTtU7Regz-vmo/exec'
//     //         const form = document.forms['submit-to-google-sheet']
//     //         console.log("Form submitted successfully:", formData);
//     //         setSubmissionStatus("Submitting...");

//     //         // Simulate form submission (replace with actual submission logic)
//     //         setTimeout(() => {
//     //             setSubmissionStatus("Thanks for contacting us! We will get back to you soon.");
//     //             setTimeout(() => {
//     //                 setSubmissionStatus(""); // Clear the status message after 5 seconds
//     //             }, 5000);

//     //             // Reset the form by clearing the state
//     //             setFormData({
//     //                 name: "",
//     //                 mobile: "",
//     //                 email: "",
//     //                 subject: "",
//     //                 message: "",
//     //             });
//     //         }, 1000);
//     //     } else {
//     //         console.log("Form contains errors:", errors);
//     //         setSubmissionStatus("Please fill out the form correctly.");
//     //     }
//     // };


//     const [name, setName] = useState('');
//     const [mobile, setMobile] = useState('');
//     const [email, setEmail] = useState('');
//     const [subject, setSubject] = useState('');
//     const [message, setMessage] = useState('');

//     const handleSubmit = (e) => {
//         e.preventDefault();

//         const data = {
//             Name: name,
//             Mobile: mobile,
//             Email: email,
//             Subject: subject,
//             Message: message,
//         };

//         axios.post('https://api.sheetbest.com/sheets/9302cdac-e5ca-4b88-bbd8-6a31f8f49ac9', data)
//             .then((response) => {
//                 setName('');
//                 setMobile('');
//                 setEmail('');
//                 setSubject('');
//                 setMessage('');
//                 // alert("Thank you for contacting us! Your message has been sent successfully. We will get back to you soon.");
//                 setSubmissionStatus("Thank you for applying! We will contact you soon.");
//                 setTimeout(() => setSubmissionStatus(""), 5000);
//             })
//             .catch((error) => {
//                 console.error(error);
//                 // alert("Something went wrong. Please try again later.");
//                 setSubmissionStatus("Something went wrong. Please try again later.");
//             });
//     };


//     return (
//         <div className="py-10 px-4 md:px-20 bg-gray-100">
//             <div className="items-center text-center">
//                 <h1 className="font-extrabold text-2xl md:text-3xl text-purple-800 mb-4">Contact Us</h1>
//                 <p className="font-bold text-lg md:text-xl text-blue-800 mb-10">
//                     We provide high standard work for your Company solutions
//                 </p>
//             </div>
//             <div className="flex flex-col md:flex-row items-start md:items-stretch justify-center gap-8">
//                 {/* Contact Information Section */}
//                 <div className="w-full md:w-1/2 bg-white shadow-md rounded-lg p-6 flex flex-col justify-between">
//                     <div className="grid grid-cols-1 gap-6">
//                         <div className="flex flex-col items-center bg-gray-50 shadow-sm rounded-lg p-4">
//                             <span className="flex flex-row gap-4">
//                                 <FaPhoneAlt className="text-purple-600 text-3xl mb-3" />
//                                 <p className="text-lg font-bold text-purple-800">Mobile</p>
//                             </span>
//                             <p className="text-gray-600">+91 9909152383</p>
//                         </div>
//                         <div className="flex flex-col items-center bg-gray-50 shadow-sm rounded-lg p-4">
//                             <span className="flex flex-row gap-4">
//                                 <FaEnvelope className="text-purple-600 text-3xl mb-3" />
//                                 <p className="text-lg font-bold text-purple-800">Email</p>
//                             </span>
//                             <p className="text-gray-600">sales.powergenic@gmail.com</p>
//                         </div>
//                         <div className="flex flex-col items-center bg-gray-50 shadow-sm rounded-lg p-4">
//                             <span className="flex flex-row gap-4">
//                                 <FaMapMarkerAlt className="text-purple-600 text-3xl mb-3" />
//                                 <p className="text-lg font-bold text-purple-800">Location</p>
//                             </span>
//                             <p className="text-gray-600">Fatima Society, Madhunagar Gorwa, Vadodara, Country-India, 390016</p>
//                         </div>
//                     </div>
//                     <div className="mt-6">
//                         <iframe
//                             src="https://maps.google.com/maps?q=D/177%20Fatima%20Park,%20Nr.%20Madhunagar,%20Gorwa,%20Vadodara,%20Gujarat%20390016&z=13&ie=UTF8&iwloc=&output=embed"
//                             width="100%"
//                             height="250"
//                             frameBorder="0"
//                             style={{ border: "2px" }}
//                             allowFullScreen
//                             title="Google Map"
//                             className="w-full rounded-lg shadow-md"
//                         ></iframe>
//                     </div>
//                 </div>

//                 {/* Contact Form Section */}
//                 <div className="w-full md:w-1/2 bg-white shadow-md rounded-lg p-6">
//                     <h2 className="text-xl md:text-2xl font-bold text-purple-800 mb-6">Get In Touch</h2>
//                     <form onSubmit={handleSubmit} name="submit-to-google-sheet" id="form">
//                         <div className="grid grid-cols-1 gap-6">
//                             <div>
//                                 <label className="block text-gray-700 font-medium mb-2">Name</label>
//                                 <input
//                                     type="text"
//                                     name="name"
//                                     value={name}
                                    
//                                     //onChange={(e) => setName(e.target.value)}
//                                     //value={formData.name}
//                                     //onChange={handleChange}
//                                     onChange={(e) => {
//                                         setName(e.target.value); // Update state
//                                         validate(e);        // Call additional handler
//                                     }}
//                                     placeholder="Enter your name"
//                                     className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"

//                                 />
//                                 {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
//                             </div>
//                             <div>
//                                 <label className="block text-gray-700 font-medium mb-2">Mobile Number</label>
//                                 <input
//                                     type="text"
//                                     name="mobile"
//                                     value={mobile}
                                    
//                                     //onChange={(e) => setMobile(e.target.value)}
//                                     // value={formData.mobile}
//                                     // onChange={handleChange}
//                                     onChange={(e) => {
//                                         setMobile(e.target.value); // Update state
//                                         handleChange(e);        // Call additional handler
//                                     }}
//                                     placeholder="Enter your mobile number"
//                                     className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
//                                 />
//                                 {errors.mobile && <p className="text-red-500 text-sm mt-1">{errors.mobile}</p>}
//                             </div>
//                             <div>
//                                 <label className="block text-gray-700 font-medium mb-2">Email</label>
//                                 <input
//                                     type="email"
//                                     name="email"
//                                     value={email}
                                    
//                                     onChange={(e) => {
//                                         setEmail(e.target.value); // Update state
//                                         handleChange(e);        // Call additional handler
//                                     }}
//                                     //onChange={(e) => setEmail(e.target.value)}
//                                     // value={formData.email}
//                                     // onChange={handleChange}
//                                     placeholder="Enter your email"
//                                     className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
//                                 />
//                                 {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
//                             </div>
//                             <div>
//                                 <label className="block text-gray-700 font-medium mb-2">Subject</label>
//                                 <input
//                                     type="text"
//                                     name="subject"
//                                     value={subject}
                                    
//                                     onChange={(e) => {
//                                         setSubject(e.target.value); // Update state
//                                         handleChange(e);        // Call additional handler
//                                     }}
//                                     //onChange={(e) => setSubject(e.target.value)}
//                                     // value={formData.subject}
//                                     // onChange={handleChange}
//                                     placeholder="Enter subject"
//                                     className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
//                                 />
//                                 {errors.subject && <p className="text-red-500 text-sm mt-1">{errors.subject}</p>}
//                             </div>
//                             <div>
//                                 <label className="block text-gray-700 font-medium mb-2">Message</label>
//                                 <textarea
//                                     name="message"
//                                     value={message}
                                    
//                                     onChange={(e) => {
//                                         setMessage(e.target.value); // Update state
//                                         handleChange(e);        // Call additional handler
//                                     }}
//                                     //onChange={(e) => setMessage(e.target.value)}
//                                     // value={formData.message}
//                                     // onChange={handleChange}
//                                     placeholder="Enter your message"
//                                     className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
//                                     rows="4"
//                                 ></textarea>
//                                 {errors.message && <p className="text-red-500 text-sm mt-1">{errors.message}</p>}
//                             </div>
//                             <div className="mt-4">

//                                 {/* Submission Status */}
//                                 {submissionStatus && (
//                                     <p className="text-center text-purple-600 mb-4">
//                                         {submissionStatus}
//                                     </p>
//                                 )}

//                                 <button
//                                     type="submit"
//                                     className="w-full bg-purple-600 text-white font-semibold py-2 rounded-lg hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
//                                 >
//                                     Submit
//                                 </button>
//                             </div>
//                         </div>
//                     </form>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ContactUs;




import React, { useState } from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import axios from "axios";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [submissionStatus, setSubmissionStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required.";
    const mobileRegex = /^[0-9]{10}$/;
    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required.";
    } else if (!mobileRegex.test(formData.mobile)) {
      newErrors.mobile = "Enter a valid 10-digit mobile number.";
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Enter a valid email address.";
    }
    if (!formData.subject.trim()) newErrors.subject = "Subject is required.";
    if (!formData.message.trim()) newErrors.message = "Message is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      const data = {
        Name: formData.name,
        Mobile: formData.mobile,
        Email: formData.email,
        Subject: formData.subject,
        Message: formData.message,
      };

      axios
        .post(
          "https://api.sheetbest.com/sheets/9302cdac-e5ca-4b88-bbd8-6a31f8f49ac9",
          data
        )
        .then((response) => {
          setFormData({
            name: "",
            mobile: "",
            email: "",
            subject: "",
            message: "",
          });
          setSubmissionStatus("Thank you for applying! We will contact you soon.");
          setTimeout(() => setSubmissionStatus(""), 5000);
        })
        .catch((error) => {
          console.error(error);
          setSubmissionStatus("Something went wrong. Please try again later.");
        });
    } else {
      setSubmissionStatus("Please fill out the form correctly.");
    }
  };

  return (
    <div className="py-10 px-4 md:px-20 bg-gray-100 mt-8">
      <div className="items-center text-center">
        <h1 className="font-extrabold text-2xl md:text-3xl text-purple-800 mb-4">
          Contact Us
        </h1>
        <p className="font-bold text-lg md:text-xl text-blue-800 mb-10">
          We provide high standard work for your Company solutions
        </p>
      </div>
      <div className="flex flex-col md:flex-row items-start md:items-stretch justify-center gap-8">
        {/* Contact Information Section */}
        <div className="w-full md:w-1/2 bg-white shadow-md rounded-lg p-6 flex flex-col justify-between">
          <div className="grid grid-cols-1 gap-6">
            <div className="flex flex-col items-center bg-gray-50 shadow-sm rounded-lg p-4">
              <span className="flex flex-row gap-4">
                <FaPhoneAlt className="text-purple-600 text-3xl mb-3" />
                <p className="text-lg font-bold text-purple-800">Mobile</p>
              </span>
              <p className="text-gray-600">+91 9909152383</p>
            </div>
            <div className="flex flex-col items-center bg-gray-50 shadow-sm rounded-lg p-4">
              <span className="flex flex-row gap-4">
                <FaEnvelope className="text-purple-600 text-3xl mb-3" />
                <p className="text-lg font-bold text-purple-800">Email</p>
              </span>
              <p className="text-gray-600">sales.powergenic@gmail.com</p>
            </div>
            <div className="flex flex-col items-center bg-gray-50 shadow-sm rounded-lg p-4">
              <span className="flex flex-row gap-4">
                <FaMapMarkerAlt className="text-purple-600 text-3xl mb-3" />
                <p className="text-lg font-bold text-purple-800">Location</p>
              </span>
              <p className="text-gray-600">
                Fatima Society, Madhunagar Gorwa, Vadodara, Country-India, 390016
              </p>
            </div>
          </div>
          <div className="mt-6">
            <iframe
              src="https://maps.google.com/maps?q=D/177%20Fatima%20Park,%20Nr.%20Madhunagar,%20Gorwa,%20Vadodara,%20Gujarat%20390016&z=13&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="250"
              frameBorder="0"
              style={{ border: "2px" }}
              allowFullScreen
              title="Google Map"
              className="w-full rounded-lg shadow-md"
            ></iframe>
          </div>
        </div>

        {/* Contact Form Section */}
        <div className="w-full md:w-1/2 bg-white shadow-md rounded-lg p-6">
          <h2 className="text-xl md:text-2xl font-bold text-purple-800 mb-6">
            Get In Touch
          </h2>
          <form onSubmit={handleSubmit} name="submit-to-google-sheet">
            <div className="grid grid-cols-1 gap-6">
              <div>
                <label className="block text-gray-700 font-medium mb-2">Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter your name"
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                />
                {errors.name && (
                  <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                )}
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2">
                  Mobile Number
                </label>
                <input
                  type="text"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  placeholder="Enter your mobile number"
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                />
                {errors.mobile && (
                  <p className="text-red-500 text-sm mt-1">{errors.mobile}</p>
                )}
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                />
                {errors.email && (
                  <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                )}
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2">Subject</label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Enter subject"
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                />
                {errors.subject && (
                  <p className="text-red-500 text-sm mt-1">{errors.subject}</p>
                )}
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2">Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Enter your message"
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                  rows="4"
                ></textarea>
                {errors.message && (
                  <p className="text-red-500 text-sm mt-1">{errors.message}</p>
                )}
              </div>
              <div className="mt-4">
                {submissionStatus && (
                  <p className="text-blue-600 font-medium mb-4">{submissionStatus}</p>
                )}
                <button
                  type="submit"
                  className="w-full bg-purple-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
